/** Static certificates and awards from `doc/certificates` (previews in `public/certificates`). */

export const CERTIFICATES = [
  {
    id: 'iso-9001-2015',
    title: 'ISO 9001:2015 Quality Management System',
    issuer: 'Otabu Certification Pvt. Ltd.',
    detail: 'Scope: Providing PU & Epoxy Coating Services. Certificate No. 0219Q272124. Valid 19 Feb 2024 – 18 Feb 2027.',
    image: '/certificates/iso-9001-2015.jpg',
    file: '/certificates/iso-9001-2015.pdf',
  },
  {
    id: 'haccp',
    title: 'HACCP — Hazard Analysis & Critical Control Point',
    issuer: 'Quality Veritas Certification Limited (UK)',
    detail: 'Scope: Providing PU Coating Services. Certificate No. 101120224. Valid 12 Feb 2024 – 11 Feb 2027.',
    image: '/certificates/haccp.jpg',
    file: '/certificates/haccp.pdf',
  },
  {
    id: 'cipet-underlay',
    title: 'CIPET Test Certificate — Deck Covering Material Underlay',
    issuer: 'CIPET Plastics Testing Centre, Hyderabad',
    detail: 'SV Bond UL 9022 A / SV Bond UL 560 B. Report No. 1605238/1. Tested as per ASTM D / NCD standards (2016).',
    image: '/certificates/cipet-underlay-test-report.jpg',
    file: '/certificates/cipet-underlay-test-report.pdf',
  },
  {
    id: 'cftri-fdg-946',
    title: 'CFTRI Test Report — SV Bond FDG 946 (USFDA 175.300)',
    issuer: 'CSIR–CFTRI, Mysore',
    detail: 'Overall migration test conforms to USFDA 175.300 for contact with potable water. Report dated 28 Nov 2014.',
    image: '/certificates/cftri-sv-bond-fdg-946.jpg',
    file: '/certificates/cftri-sv-bond-fdg-946.pdf',
  },
  {
    id: 'cftri-slf-936',
    title: 'CFTRI Test Report — SV Bond SLF 936 (USFDA 175.300)',
    issuer: 'CSIR–CFTRI, Mysore',
    detail: 'Overall migration test conforms to USFDA 175.300 for contact with potable water. Report dated 28 Nov 2014.',
    image: '/certificates/cftri-sv-bond-slf-936.jpg',
    file: '/certificates/cftri-sv-bond-slf-936.pdf',
  },
  {
    id: 'cftri-ul-9022',
    title: 'CFTRI Test Report — SV Bond UL 9022 A / UL 560 B (USFDA 175.300)',
    issuer: 'CSIR–CFTRI, Mysore',
    detail: 'Overall migration test conforms to USFDA 175.300 for contact with potable water. Report dated 28 Nov 2014.',
    image: '/certificates/cftri-sv-bond-ul-9022.jpg',
    file: '/certificates/cftri-sv-bond-ul-9022.pdf',
  },
];

export const AWARDS = [
  {
    id: 'elantas-award-merit-pharma',
    title: 'Award of Merit — Best Project, Industrial Flooring (Pharma)',
    issuer: 'ELANTAS Beck India Ltd.',
    detail: 'Presented to Sai Vikas Enterprises, Pune. Goa, August 2012.',
    image: '/certificates/elantas-award-merit-pharma.jpg',
    file: '/certificates/elantas-award-merit-pharma.pdf',
  },
  {
    id: 'beck-authorised-applicator-2005',
    title: 'Authorised Applicator & Best Applicator 2005',
    issuer: 'Beck India Limited (ALTANA)',
    detail: 'Authorised applicator for the Beck Bond range of anti-corrosive epoxy coatings, linings and floorings. Adjudged one of the best applicators in 2005 for sugar and related industry. Letter dated 11 Jan 2006.',
    image: '/certificates/beck-authorised-applicator-2005.jpg',
    file: '/certificates/beck-authorised-applicator-2005.pdf',
  },
];
